let top_menu = {
  home: "Home",
  package: "Package Purchase",
  api: "API acquisition",
  application: "Application scenarios",
  resource: "Resource Center",
  login: "LOG IN",
  register: "REGISTER",
  sign_out: "SIGN OUT"
}
export default top_menu


// WEBPACK FOOTER //
// ./src/assets/lang/en/top/index.js